<template>
  <vs-popup title="Clôturer le problème" :active.sync="isPromptActiveLocal">
    <vs-row>
      <p class="mt-5">RCA <b style="color: #ff6141">*</b></p>
      <vs-textarea
        rows="5"
        v-model="form.root_cause"
        class="w-full"
        name="item-request"
      />
    </vs-row>
    <vs-row>
      <p class="mt-5">Solution <b style="color: #ff6141">*</b></p>
      <vs-textarea
        rows="5"
        v-model="form.solution"
        class="w-full"
        name="item-request"
      />
    </vs-row>

    <vs-row>
      <vs-button
        :disabled="!isFormValid"
        color="primary"
        class="mt-2 mr-2"
        type="filled"
        @click="submit()"
        >Enregister</vs-button
      >
      <vs-button
        color="primary"
        class="mt-2"
        type="border"
        @click="$emit('closePrompt')"
        >Annuler</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  name: "closeProblem",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    closeCallBack: {
      type: Function,
    },
    problem: {
      type: Object,
      required: true,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          this.resetErrors();
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
    isFormValid() {
      var is_valide = true;
      if (!this.form.root_cause || this.form.root_cause === "")
        is_valide = false;
      if (!this.form.solution || this.form.solution === "") is_valide = false;

      return is_valide;
    },
  },
  data: () => ({
    form: {
      root_cause: "",
      solution: "",
    },
    formErrors: {},
  }),

  methods: {
    submit() {
      this.$vs.loading();
      this.form.id = this.problem.id;
      this.$http
        .post("problems/close", this.form)
        .then((response) => {
          this.$vs.loading.close();

          if (response.data.status == true) {
            this.$vs.notify({
              title: "Succès",
              text: "Opération effectuée avec succès",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.resetErrors();
            this.$emit("closePrompt");
            this.closeCallBack();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          } else {
            this.$vs.notify({
              title: "Erreur",
              text: "Veuillez valider les champs du formulaire",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.formErrors = error.response.data.errors;
          }
        });
    },
    resetErrors(field) {
      if (field) {
        this.formErrors[field] = null;
      } else {
        this.formErrors = [];
        Object.keys(this.form).forEach((index) => (this.form[index] = null));
      }
    },
  },
};
</script>

<style scoped>
</style>
